import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0224',
    ecrans: ['00-2']
});
